// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-4fb1f84d]:first-of-type{padding-bottom:2.5rem;padding-top:2.5rem}section[data-v-4fb1f84d]:not(:first-of-type){padding-bottom:3.5rem;padding-top:3.5rem}details>summary[data-v-4fb1f84d]{list-style-type:none}details>summary[data-v-4fb1f84d]::-webkit-details-marker,details>summary[data-v-4fb1f84d]::marker{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
